<template>
  <Modal>
    <form
      @submit.prevent="onSubmit"
      :style="styles.modalForm"
    >
      <div :style="styles.userInputContainer">
        <span :style="styles.inputLabel">USER ID</span>
        <input
          type="text"
          placeholder="Enter a valid User ID"
          v-model="userId"
          :style="styles.userInput"
        />
      </div>
      <div :style="styles.userInputContainer">
        <span :style="styles.inputLabel">ENVIRONMENT</span>
        <select :style="styles.inputSelect"v-model="stage">
          <option selected disabled>Choose an environment...</option>
          <option value="test" default>Test</option>
          <option value="prod">Production</option>
        </select>
      </div>
      <div :style="styles.submitButtonContainer">
        <button type="submit">Reset Deck</button>
      </div>
    </form>
  </Modal>

</template>
<script>
import Modal from '../general/Modal';
import ls from 'local-storage';
import store from '../../store';
import { postResource } from '../../services/Utils.js';
export default {
  name: 'ColdDeckResetModal',
  components: {
    Modal
  },
  computed: {
    getTenant() {
      return store.getters.getTenant;
    },
  },
  methods: {
    onSubmit() {
      console.log('form submitted');
      const stage = this.stage;
      const userId = this.userId;
      const tenant = this.getTenant;
      const tenantId = tenant.platform_id;
      console.log(tenantId);
      if (!userId || !userId.length)
        return alert('Please enter a valid User ID and try again.');
      const bool = confirm(
        `Do you want to proceed with resetting User ${userId} deck?`
      );
      if (bool) {
        postResource(`/v1/tenants/coldStart?userId=${userId}&env=${stage}`)
          .then(res => res.json())
          .then(res => {
            if (res.status === 'success') {
              alert(`Deck successfully reset for User ${userId}`);
            } else {
              alert(
                'Reset failed. Please check console logs for more details.'
              );
              console.log(res);
            }
          });
      }
    },
    logout() {
      store.commit('hideModals', true);
      ls.set('GEG__KEY', '');
      this.$router.push('/');
    },
  },
  data() {
    return {
      userId: null,
      stage: null,
      styles: {
        toggleColdDeckIcon: {
          position: 'fixed',
          top: '10px',
          right: '10px',
          fontSize: '2em',
          color: '#ddd',
          cursor: 'pointer'
        },
        modalForm: {
          padding: '20px',
          width: '100%',
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        userInputContainer: {
          padding: '10px 0',
          width: '100%',
          display: 'flex',
          flexFlow: 'column nowrap',
        },
        userInput: {
          padding: '10px',
          width: '100%'
        },
        inputSelect: {
          padding: '10px',
          fontSize: '1em',
        },
        submitButtonContainer: {
          padding: '10px 0'
        },
        inputLabel: {
          fontSize: '0.9em',
          fontWeight: '700',
          margin: '10px 0 5px'
        },
      }
    };
  }
};
</script>
<style lang="scss" scoped>
button {
  border-radius: 100px;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 10px 30px;
  margin: 10px auto;
  display: block;
  outline: 0;
  border: 0;
  // width: 45%;

  @media all and (max-width: 640px) {
    width: 100%;
    margin: 0.5rem;
  }

  color: #fff;
  background: #00a8e0;
  transition: all 0.2s;

  &:hover {
    background: darken(#00a8e0, 10%);
  }
}
</style>





// WEBPACK FOOTER //
// src/components/modals/ColdDeckReset.vue